import {store} from "../../store";

const GetErpTypeFromConfig = () => {
  const state = store.getState();
  const erpType = state.search.erpType;
  return erpType;
};
let ERP_TYPE = GetErpTypeFromConfig();
const erpTypeName = 'MEX';

const durationTemplate = (args: any) => {
  const startDate = new Date(args.scheduled_start_date);
  const endDate = new Date(args.scheduled_end_date);

  let difference = endDate.getTime() - startDate.getTime();

  let differenceAsDays = Math.round(difference / (1000 * 3600 * 24));
  return (
    <div>
      {differenceAsDays > 0 ? (
        <div>
          <span>{differenceAsDays}</span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
export const plannedOrderColumns = [
  {
    type: 'checkbox',
    width: '50',
    field: 'isChecked',
    showInColumnChooser: true,
    allowFiltering: true,
    allowGrouping: false,
    allowSearching: false,
  },
  {
    field: 'app',
    textAlign: 'Left',
    headerText: 'App',
    width: 80,
    visible: false,
  },
  {
    field: 'order_id',
    textAlign: 'Left',
    headerText: 'Workorder ID',
    width: 80,
    visible: false,
    isPrimaryKey: true,
  },
  {
    field: 'order_code_id',
    textAlign: 'Left',
    headerText: 'Workorder code ID',
    width: 80,
    visible: false,
  },
  {
    field: 'isEffected',
    textAlign: 'Left',
    width: 50,
    visible: false,
    clipMode: 'EllipsisWithTooltip',
    type: 'boolean',
  },

  {
    field: 'priority_code',
    headerText: 'Priority Code',
    width: 150,
    clipMode: 'EllipsisWithTooltip',
  },
  {
    field: 'asset_code_parent',
    headerText: 'Parent Asset',
    visible: ERP_TYPE === erpTypeName ? true : false,
    width: 140,
    clipMode: 'EllipsisWithTooltip',
  },
  {
    field: 'material_status',
    headerText: 'Material Status',
    width: 40,
    visible: ERP_TYPE === erpTypeName ? false : true,
    clipMode: 'EllipsisWithTooltip',
  },

  {
    field: 'asset_code',
    headerText: 'Asset Code',
    width: 150,
    clipMode: 'EllipsisWithTooltip',
  },
  {
    field: 'asset_description',
    headerText: 'Asset Description',
    clipMode: 'EllipsisWithTooltip',
    visible: ERP_TYPE === erpTypeName ? true : false,
    allowEditing: true,
  },
  {
    field: 'order_code',
    textAlign: 'Left',
    headerText: 'Workorder Code',
    width: 150,
    isPrimaryKey: true,
    clipMode: 'EllipsisWithTooltip',
  },
  {
    field: 'description',
    headerText: 'WO Description',
    clipMode: 'EllipsisWithTooltip',
    allowEditing: true,
  },
  {
    field: 'department_code',
    headerText: 'Department',
    visible: ERP_TYPE === erpTypeName ? true : false,
    clipMode: 'EllipsisWithTooltip',
    allowEditing: true,
  },
  {
    field: 'status_code',
    headerText: 'Status Code',
    width: 150,
    clipMode: 'EllipsisWithTooltip',
    allowEditing: true,
  },
  {
    field: 'type_code',
    headerText: 'Type Code',
    width: 150,
    clipMode: 'EllipsisWithTooltip',
    allowEditing: true,
  },
  {
    field: 'order_resp_code',
    headerText: 'Responsibility',
    width: 150,
    visible: ERP_TYPE === erpTypeName ? false : true,
    clipMode: 'EllipsisWithTooltip',
    allowEditing: true,
  },
  {
    field: 'scheduled_start_date',
    headerText: 'Scheduled Start Date',
    width: 200,
    clipMode: 'EllipsisWithTooltip',
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm:ss',
    allowEditing: false,
  },

  {
    field: 'scheduled_end_date',
    headerText: 'Scheduled End Date',
    width: 200,
    clipMode: 'EllipsisWithTooltip',
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm:ss',
    editType: 'datetimepickeredit',
    allowEditing: false,
  },
  {
    field: 'duration',
    template: durationTemplate.bind(this),
    headerText: 'Duration',
    width: 150,
  },

  {
    field: 'planned_start_date',
    headerText: 'Planned Start Time',
    width: 200,
    clipMode: 'EllipsisWithTooltip',
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm:ss',
    allowEditing: false,
    edit: { params: { format: 'dd/MM/yyyy HH:mm:ss' } },
  },
  {
    field: 'planned_end_date',
    headerText: 'Planned End Time',
    width: 200,
    clipMode: 'EllipsisWithTooltip',
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm:ss',
    allowEditing: true,
    edit: { params: { format: 'dd/MM/yyyy HH:mm:ss' } },
  },
  {
    field: 'duration',
    template: durationTemplate.bind(this),
    headerText: 'Planned Duration',
    width: 200,
    visible: ERP_TYPE === erpTypeName ? true : false,
  },
  {
    field: 'actual_start_date',
    headerText: 'Actual Start Date',
    width: 200,
    clipMode: 'EllipsisWithTooltip',
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm:ss',
    allowEditing: true,
    edit: { params: { format: 'dd/MM/yyyy HH:mm:ss' } },
    visible: ERP_TYPE === erpTypeName ? true : false,
  },
  {
    field: 'actual_end_date',
    headerText: 'Actual End Time',
    width: 150,
    clipMode: 'EllipsisWithTooltip',
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm:ss',
    allowEditing: true,
    edit: { params: { format: 'dd/MM/yyyy HH:mm:ss' } },
    visible: ERP_TYPE === erpTypeName ? true : false,
  },
  {
    field: 'site_details_1',
    headerText: 'Reference',
    width: 150,
    clipMode: 'EllipsisWithTooltip',
    visible: ERP_TYPE === erpTypeName ? true : false,
    allowEditing: true,
  },
  {
    field: 'creation_date',
    headerText: 'Created Date',
    width: 140,
    clipMode: 'EllipsisWithTooltip',
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm:ss',
    visible: ERP_TYPE === erpTypeName ? true : false,
    allowEditing: true,
  },
  {
    field: 'created_by',
    headerText: 'Created By',
    width: 140,
    clipMode: 'EllipsisWithTooltip',
    visible: ERP_TYPE === erpTypeName ? true : false,
    allowEditing: true,
  },
  {
    field: 'order_branch',
    headerText: 'Account Code',
    width: 140,
    clipMode: 'EllipsisWithTooltip',
    visible: ERP_TYPE === erpTypeName ? true : false,
    allowEditing: true,
  },
  {
    field: 'wo_labour_cost',
    headerText: 'Labour Cost',
    width: 150,
    clipMode: 'EllipsisWithTooltip',
    visible: ERP_TYPE === erpTypeName ? true : false,
    allowEditing: true,
    format: 'C2',
  },
  {
    field: 'wo_material_cost',
    headerText: 'Material Cost',
    width: 150,
    clipMode: 'EllipsisWithTooltip',
    visible: ERP_TYPE === erpTypeName ? true : false,
    allowEditing: true,
    format: 'C2',
  },
  {
    field: 'wo_other_cost',
    headerText: 'Other Cost',
    width: 150,
    clipMode: 'EllipsisWithTooltip',
    visible: ERP_TYPE === erpTypeName ? true : false,
    allowEditing: true,
    format: 'C2',
  },
  {
    field: 'pm_schedule_id',
    headerText: 'PM Schedule ID',
    width: 150,
    clipMode: 'EllipsisWithTooltip',
  },

  {
    field: 'team_code',
    headerText: 'Team',
    width: 110,
    visible: ERP_TYPE === erpTypeName ? false : true,
    clipMode: 'EllipsisWithTooltip',
  },
  {
    field: 'shift',
    headerText: 'Shift',
    width: 110,
    visible: ERP_TYPE === erpTypeName ? false : true,
    clipMode: 'EllipsisWithTooltip',
    allowEditing: true,
  },
  {
    field: 'order_section_code',
    headerText: 'Section',
    width: 120,
    visible: ERP_TYPE === erpTypeName ? false : true,
    clipMode: 'EllipsisWithTooltip',
    allowEditing: true,
  },
  {
    field: 'order_branch',
    headerText: 'Branch',
    width: 40,
    visible: ERP_TYPE === erpTypeName ? false : true,
    clipMode: 'EllipsisWithTooltip',
    allowEditing: false,
  },
  {
    field: 'site_details_2',
    headerText: 'Site Details 2',
    width: 40,
    clipMode: 'EllipsisWithTooltip',
    visible: false,
    allowEditing: true,
  },
  {
    field: 'site_details_3',
    headerText: 'Site Details 3',
    width: 40,
    clipMode: 'EllipsisWithTooltip',
    visible: false,
    allowEditing: true,
  },
  {
    field: 'entered_by',
    headerText: 'Entered By',
    width: 40,
    visible: ERP_TYPE === erpTypeName ? false : true,
    clipMode: 'EllipsisWithTooltip',
    allowEditing: true,
  },
  {
    field: 'approval_date',
    headerText: 'Approval Date',
    width: 150,
    clipMode: 'EllipsisWithTooltip',
    type: 'datetime',
    format: 'dd/MM/yyyy HH:mm:ss',
    edit: { params: { format: 'dd/MM/yyyy HH:mm:ss' } },
    visible: false,
    allowEditing: true,
  },
];
